import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TestimonialBox } from '../components/TestimonialBox';
import { ProductSidebar } from '../components/ProductSidebar';
import { CTASection } from '../components/CTASection';
import { StickyBottomBar } from '../components/StickyBottomBar';
export function AdvertorialPage() {
  const testimonials = [{
    author: 'Mark T., 46',
    location: 'Phoenix, AZ',
    quote: 'After 15 years of nightly beers, I stopped wanting them in week one. My wife says she has her husband back. My kids have their dad back. I have myself back.'
  }, {
    author: 'David K., 41',
    location: 'Dallas, TX',
    quote: 'The 3 AM wake-ups were destroying me. Heart racing, mind spinning, thinking I was having a heart attack. Now I sleep through the night. My anxiety is just... gone.'
  }, {
    author: 'Robert M., 54',
    location: 'Seattle, WA',
    quote: 'I spent thousands on supplements and therapy trying to quit. This patch did what nothing else could—it calmed my nervous system down. Within 10 days the craving went from a 9 to a 2.'
  }, {
    author: 'James R., 38',
    location: 'Charlotte, NC',
    quote: "I can finally be the dad I wanted to be. Present at bedtime. Patient with my kids. Proud of who I am. I didn't know life could feel this calm."
  }, {
    author: 'Michael W., 49',
    location: 'Portland, OR',
    quote: "I tried everything. This patch was the first thing that actually addressed WHY I was drinking—my nervous system was fried. Two weeks in and I'm a different person."
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-128">
      <Header data-id="element-129" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-130">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-131">
          {/* Main Content Column */}
          <article className="w-full lg:w-[65%]" data-id="element-132">
            <Hero data-id="element-133" />

            {/* IMAGE 1: Father and son in backyard */}
            <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-134">
              <img src="https://cdn.magicpatterns.com/uploads/fpssN1c9GqYd67MWSzztCU/ChatGPT_Image_6_Φεβ_2026,_06_16_10_μ.μ..png" alt="Father and son in backyard, football on ground between them, evening light, son looking down, dad distracted/distant" className="w-full h-auto rounded-lg" data-id="element-135" />
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 font-serif leading-relaxed" data-id="element-136">
              <p className="text-xl mb-6 font-semibold text-gray-900" data-id="element-137">
                I still remember that Saturday afternoon like it was yesterday.
              </p>

              <p className="mb-6" data-id="element-138">
                I was sitting on the couch at 6 PM, already three beers deep. My
                11-year-old son Jake walked in holding his football.
              </p>

              <p className="mb-6" data-id="element-139">
                "Dad, wanna throw the ball before it gets dark?"
              </p>

              <p className="mb-6" data-id="element-140">
                I looked at him. Then at the beer in my hand. Then at the clock.
              </p>

              <p className="mb-6" data-id="element-141">"Maybe later, bud. I'm tired."</p>

              <p className="mb-6" data-id="element-142">
                He nodded. Didn't argue. Just walked back outside alone.
              </p>

              <p className="mb-6" data-id="element-143">
                That's when I realized: he'd stopped expecting me to say yes.
              </p>

              <p className="mb-6" data-id="element-144">
                He'd learned that Evening Dad wasn't the same person as Morning
                Dad. That by 6 PM, I was already checked out. Already three
                beers in. Already gone.
              </p>

              <p className="mb-8" data-id="element-145">And that fucking destroyed me.</p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-146">
                The Nightly Cycle I Couldn't Break
              </h2>

              <p className="mb-6" data-id="element-147">
                It happened the same way every single night.
              </p>

              <p className="mb-6" data-id="element-148">
                I'd wake up that morning with the familiar shame hangover—the
                physical pain mixed with the crushing guilt of broken promises.
                I'd stand in the shower making the same vow I'd made hundreds of
                times before: "Not tonight. Tonight I'm in control."
              </p>

              <p className="mb-6" data-id="element-149">And I meant it. I really did.</p>

              <p className="mb-6" data-id="element-150">
                I'd make it through the workday. Close deals. Lead meetings. Be
                the guy everyone counted on.
              </p>

              <p className="mb-6" data-id="element-151">Then 5:30 PM would hit.</p>

              <p className="mb-6" data-id="element-152">
                I'm driving home from work, and all I can think about is that
                first beer. Not because I had a bad day. Not because I'm
                celebrating.
              </p>

              <p className="mb-6" data-id="element-153">Because my body is screaming for it.</p>

              <p className="mb-6" data-id="element-154">
                By the time I walk through the door, I'm already opening the
                fridge. One beer. Then two. Then I've finished a six-pack and
                it's 9 PM and I don't even remember the last three hours.
              </p>

              {/* IMAGE 2: Kitchen counter with beer cans */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-155">
                <img src="https://cdn.magicpatterns.com/uploads/1pwr8ddXzEyigNVLzbovwc/ChatGPT_Image_6_Φεβ_2026,_06_16_08_μ.μ..png" alt="Kitchen counter at 6 PM with beer cans, man's hand reaching for another" className="w-full h-auto rounded-lg" data-id="element-156" />
              </div>

              <p className="mb-6" data-id="element-157">
                My wife stopped trying to have real conversations with me after
                7 PM. She knows Evening Me isn't the same person as Morning Me.
              </p>

              <p className="mb-6" data-id="element-158">
                My son stopped asking me to play catch. Or throw the football.
                Or shoot hoops.
              </p>

              <p className="mb-6" data-id="element-159">He just... stopped asking.</p>

              <p className="mb-6" data-id="element-160">
                The worst part? I'd wake up at 3 AM in a panic—heart racing,
                sheets drenched in sweat, replaying the evening I couldn't fully
                remember. Did I snap at my wife? Did I ignore my son? Did I send
                any stupid texts to clients?
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-161">
                The anxiety was crushing. The shame was unbearable.
              </p>

              <p className="mb-8" data-id="element-162">
                And the next morning, the cycle would start all over again.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-163">
                I Tried Everything (And Failed at All of It)
              </h2>

              <p className="mb-6" data-id="element-164">
                If you're reading this, you've probably tried some of these too.
              </p>

              <p className="mb-6" data-id="element-165">
                I made rules. Only on weekends. Only after 8 PM. Only two beers.
              </p>

              <p className="mb-6" data-id="element-166">Broke them all by Thursday.</p>

              <p className="mb-6" data-id="element-167">
                I tried switching from beer to wine, thinking it would be easier
                to control. It wasn't.
              </p>

              <p className="mb-6" data-id="element-168">
                I tried going cold turkey once. Made it 36 hours before the
                shaking started. My hands trembled so badly I couldn't type. The
                anxiety was crushing. I gave in because I was genuinely scared.
              </p>

              {/* IMAGE 3: Failed attempts - supplements, tracker, rules */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-169">
                <img src="https://cdn.magicpatterns.com/uploads/4YWnxnxKHwXXbHdREHAsVh/ChatGPT_Image_6_Φεβ_2026,_06_16_07_μ.μ..png" alt="Flat lay of failed attempts: supplement bottles, fitness tracker, handwritten rules crossed out" className="w-full h-auto rounded-lg" data-id="element-170" />
              </div>

              <p className="mb-6" data-id="element-171">
                I'm not going to AA. I'm not that guy. I run a business. I have
                a family. I don't have time to sit in circles talking about my
                feelings.
              </p>

              <p className="mb-6" data-id="element-172">
                I tried supplements. Every "liver detox" and "craving reducer"
                on Amazon. Milk thistle. B vitamins. Magnesium. Spent hundreds
                of dollars. Got absolutely nothing.
              </p>

              <p className="mb-6" data-id="element-173">
                I tried therapy. Six sessions with a counselor who kept asking
                me about my childhood. Look, my childhood was fine. My PRESENT
                is the problem.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-174">
                I was exhausted. Financially drained. Emotionally destroyed.
              </p>

              <p className="mb-8" data-id="element-175">And I was running out of hope.</p>

              <p className="mb-8 italic text-gray-700" data-id="element-176">
                If this sounds familiar, keep reading—because what I discovered
                next changed everything.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-177">
                The Conversation That Changed My Life
              </h2>

              <p className="mb-6" data-id="element-178">
                It was my brother-in-law Mike who finally broke through.
              </p>

              <p className="mb-6" data-id="element-179">
                We were at a family BBQ three months ago. He pulled me aside
                while everyone else was eating.
              </p>

              {/* IMAGE 4: Two men having serious conversation */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-180">
                <img src="https://cdn.magicpatterns.com/uploads/xkoKDBDsgxTPgW1A9CVXfa/ChatGPT_Image_6_Φεβ_2026,_06_16_05_μ.μ..png" alt="Two men having a serious conversation, backyard BBQ setting" className="w-full h-auto rounded-lg" data-id="element-181" />
              </div>

              <p className="mb-6" data-id="element-182">
                "You're drinking every night, aren't you?" he said.
              </p>

              <p className="mb-6" data-id="element-183">
                I started to deflect. "I mean, it's just a few beers after work.
                I'm not—"
              </p>

              <p className="mb-6" data-id="element-184">He stopped me.</p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-185">
                "I was doing the same thing. Six beers a night, every night, for
                eight years. Thought I had it under control because I wasn't
                missing work or getting DUIs."
              </p>

              <p className="mb-6" data-id="element-186">
                "But my body was in crisis mode 24/7. Cortisol spiked all day.
                Brain couldn't produce calm on its own anymore. By evening,
                alcohol was the only thing that shut off the alarm bells."
              </p>

              <p className="mb-6" data-id="element-187">I stared at him. "What do you mean?"</p>

              <p className="mb-6" data-id="element-188">
                He took a breath. "I've been where you are. The nightly beers.
                The 3 AM wake-ups. The shame. I thought I was weak. But then I
                learned something that changed everything."
              </p>

              <p className="mb-6" data-id="element-189">
                He explained that after years of chronic stress—work pressure,
                family responsibilities, life's constant demands—our bodies get
                stuck in what's called "sympathetic dominance." Our nervous
                system gets locked in fight-or-flight mode. The gas pedal is
                stuck down and the brake pedal has gone silent.
              </p>

              <p className="mb-6" data-id="element-190">
                "By evening," he said, "your body is so overstimulated that it's
                chemically demanding something—anything—to shut off the alarm
                bells. That's not weakness. That's biology."
              </p>

              <p className="mb-6" data-id="element-191">
                For the first time in years, someone was telling me this wasn't
                my fault.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-192">
                "There's a way to fix it," Mike said quietly. "But it's not what
                you think."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-193">
                Why Everything I Tried Before Was Doomed to Fail
              </h2>

              <p className="mb-6" data-id="element-194">
                Over the next hour, Mike explained something I'd never heard
                from any therapist or any article I'd read at 2 AM.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-195">
                The reason willpower never worked wasn't because I was weak. It
                was because I was trying to solve a physiological problem with
                psychological tools.
              </p>

              <p className="mb-6" data-id="element-196">
                Here's what's actually happening in your body when you can't
                stop drinking:
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-197">
                The Cortisol-Craving Loop
              </h3>

              <p className="mb-6" data-id="element-198">
                Chronic stress floods your body with cortisol all day long. This
                stress hormone keeps your nervous system locked in emergency
                mode—constantly alert, constantly activated, constantly on edge.
              </p>

              <p className="mb-6" data-id="element-199">
                By the time evening rolls around, your brain is desperate for
                relief from that constant state of alarm. And alcohol? Alcohol
                temporarily forces your nervous system to calm down.
              </p>

              <p className="mb-6" data-id="element-200">
                So your body learns: "Beer = relief from cortisol overload."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-201">
                It's not a habit. It's not a choice. It's a chemical dependency
                your stressed-out body has developed just to survive.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-202">
                The Sympathetic Dominance Problem
              </h3>

              <p className="mb-6" data-id="element-203">
                Think of your nervous system like a car with two pedals. The
                sympathetic nervous system is the gas pedal (alert, active,
                stressed). The parasympathetic nervous system is the brake pedal
                (calm, relaxed, recovered).
              </p>

              <p className="mb-6" data-id="element-204">
                Most people's nervous systems naturally shift between the two
                throughout the day. Gas pedal during work. Brake pedal in the
                evening.
              </p>

              <p className="mb-6" data-id="element-205">
                But years of chronic stress—combined with nightly drinking—have
                broken that system. Your gas pedal is stuck down. Your brake
                pedal doesn't work anymore.
              </p>

              <p className="mb-8" data-id="element-206">
                Alcohol is the only thing that forces your foot off the gas.
                That's why "just two beers" feels impossible. Your body isn't
                looking for a drink—it's looking for the only emergency brake it
                knows.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-207">
                Why White-Knuckling Doesn't Work
              </h3>

              <p className="mb-6" data-id="element-208">
                When you try to quit through willpower alone, you're asking a
                flooded nervous system to calm itself using thoughts.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-209">
                That's like trying to stop a fire by telling it to stop burning.
              </p>

              <p className="mb-6" data-id="element-210">
                It doesn't matter how motivated you are. It doesn't matter how
                much you love your family. Your body is in a state of
                physiological crisis and it will do whatever it takes to find
                relief.
              </p>

              <p className="mb-8" data-id="element-211">
                Mike looked at me and said, "That's why every attempt you've
                made has failed. You were trying to fix a nervous system problem
                with discipline. It was never going to work."
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-212">
                Then He Told Me About the Solution
              </h2>

              <p className="mb-6" data-id="element-213">
                "I tried something three months ago," Mike said. "A patch."
              </p>

              <p className="mb-6" data-id="element-214">
                I almost laughed. A patch? After all the things I'd tried, a
                PATCH was supposed to fix this?
              </p>

              <p className="mb-6" data-id="element-215">But Mike wasn't smiling. He was serious.</p>

              <p className="mb-6" data-id="element-216">
                "It's not a nicotine patch or anything addictive," he explained.
                "It delivers ingredients that actually calm your nervous system.
                Continuously. For 24 hours."
              </p>

              {/* IMAGE 5: Man showing discreet patch on upper arm */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-217">
                <img src="https://cdn.magicpatterns.com/uploads/3GX81tXnLRY6faQhpty33M/ChatGPT_Image_6_Φεβ_2026,_06_16_04_μ.μ..png" alt="Close-up of a discreet transdermal patch on a man's upper arm" className="w-full h-auto rounded-lg" data-id="element-218" />
              </div>

              <p className="mb-6" data-id="element-219">
                He told me it was designed specifically for people like
                us—high-functioning adults whose drinking is driven by an
                overstimulated stress response, not by addiction in the
                traditional sense.
              </p>

              <p className="mb-6" data-id="element-220">
                "It gives your body what it's been screaming for," he said.
                "Support for your nervous system. The nutrients alcohol has
                depleted. A way to actually calm down without needing beer to do
                it."
              </p>

              <p className="mb-6" data-id="element-221">
                I was skeptical. After so many failed attempts, hope felt
                dangerous.
              </p>

              <p className="mb-6" data-id="element-222">
                But Mike looked different. Sharper. Present. Like he'd gotten
                his edge back.
              </p>

              <p className="mb-6 text-lg italic text-gray-700 pl-6 border-l-4 border-[#1E4D3D]" data-id="element-223">
                "I haven't wanted beer in ten weeks," he said. "Not craved it.
                Not white-knuckled my way through an evening. I just... don't
                want it anymore. And I sleep through the night now. No more 3 AM
                panic."
              </p>

              <p className="mb-6" data-id="element-224">
                I looked at him. He'd always been the guy with a beer in his
                hand at every family gathering. The loud one who got louder and
                sloppier as the night went on.
              </p>

              <p className="mb-6" data-id="element-225">But now? He looked calm. In control.</p>

              <p className="mb-6" data-id="element-226">
                "It's called Glisera," he said. "And if you're ready, I think it
                could change your life."
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-227">
                That night, I ordered it.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-228">
                What Happened in the First Week
              </h2>

              <p className="mb-6" data-id="element-229">
                The package arrived three days later in plain brown packaging.
                No one would ever know what was inside.
              </p>

              <p className="mb-6" data-id="element-230">
                I opened it in my garage with shaking hands. Inside was a
                month's supply of patches and simple instructions: apply one
                patch to your upper arm or shoulder blade each morning. Wear it
                for 24 hours. Replace daily.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-231">
                Day 1:
              </h3>

              <p className="mb-6" data-id="element-232">
                I put on the first patch that Thursday morning. It was small,
                thin, and completely invisible under my shirt.
              </p>

              <p className="mb-6" data-id="element-233">Honestly? I didn't feel anything dramatic.</p>

              <p className="mb-6" data-id="element-234">
                But that evening, something was different. It was 5:30 PM—my
                usual "beer o'clock." I was driving home from work, and normally
                by that point I'd already be thinking about that first beer.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-235">
                But the screaming urge wasn't there. It was more like...
                background noise. Like someone had turned the volume down from a
                10 to maybe a 6.
              </p>

              <p className="mb-6" data-id="element-236">
                I got home. Opened the fridge. Grabbed a beer out of habit.
              </p>

              <p className="mb-6" data-id="element-237">
                I drank two that night instead of six. And I actually remembered
                putting my son to bed. We talked about his day. Really talked.
              </p>

              <p className="mb-8" data-id="element-238">
                I slept restlessly—probably still adjusting—but I didn't wake up
                at 3 AM in a panic. That alone felt like a miracle.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-239">
                Day 2:
              </h3>

              <p className="mb-6" data-id="element-240">
                Friday morning I woke up without the usual fog. My head felt
                clearer than it had in months.
              </p>

              <p className="mb-6" data-id="element-241">
                I changed the patch and went to work. The afternoon was easier.
                The evening was easier.
              </p>

              <p className="mb-6" data-id="element-242">
                That night, I had one beer with dinner. Just one. And I didn't
                feel desperate for more.
              </p>

              <p className="mb-6" data-id="element-243">
                My wife noticed. "You seem more present tonight," she said.
              </p>

              <p className="mb-8" data-id="element-244">"Yeah," I said. And I meant it.</p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-245">
                Day 3:
              </h3>

              <p className="mb-6" data-id="element-246">
                Saturday was the real test. Weekends were always my worst. No
                work structure. More time at home. The perfect excuse to start
                drinking at 2 PM.
              </p>

              <p className="mb-6" data-id="element-247">
                But that morning, I woke up at 6 AM naturally. No alarm. No
                panic. Just... awake.
              </p>

              <p className="mb-6" data-id="element-248">
                My son came into the kitchen around 8. I was making eggs.
              </p>

              {/* IMAGE 6: Father and son reconnecting - cooking together */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-249">
                <img src="https://cdn.magicpatterns.com/uploads/478dreLWvCEzUoX5e126EN/ChatGPT_Image_6_Φεβ_2026,_06_16_02_μ.μ..png" alt="Father and son in kitchen, morning, cooking together, reconnecting" className="w-full h-auto rounded-lg" data-id="element-250" />
              </div>

              <p className="mb-6" data-id="element-251">
                He looked at me for a moment—really looked at me—and said, "Dad,
                you wanna throw the ball later?"
              </p>

              <p className="mb-6" data-id="element-252">"Yeah, bud. Absolutely."</p>

              <p className="mb-6" data-id="element-253">
                We played for two hours that afternoon. I was fully there. Fully
                present. Not thinking about beer. Not counting down until I
                could crack one open.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-254">
                Just... playing catch with my son.
              </p>

              <p className="mb-6" data-id="element-255">
                That night we had a family movie night. Everyone else was
                drinking. I had sparkling water.
              </p>

              <p className="mb-8" data-id="element-256">
                And here's the thing: I didn't feel left out. I didn't feel like
                I was missing something. The urge to drink was barely a whisper.
              </p>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-257">
                The screaming demon that had controlled my evenings for years
                had gone quiet.
              </p>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-258">
                Day 7:
              </h3>

              <p className="mb-6" data-id="element-259">
                By the end of week one, I felt like a different person.
              </p>

              <p className="mb-6" data-id="element-260">
                I was sleeping through the night—deep, restorative sleep. I'd
                wake up at 5:45 AM sharp, no alarm, clear-headed.
              </p>

              <p className="mb-6" data-id="element-261">
                The constant low-level anxiety that had been my shadow for years
                had lifted. I felt calm. Not numb—truly calm.
              </p>

              <p className="mb-6" data-id="element-262">
                My face looked different in the mirror. Less puffy. Less tired.
                My eyes were clearer.
              </p>

              {/* IMAGE 7: Man looking at himself in mirror - transformation */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-263">
                <img src="https://cdn.magicpatterns.com/uploads/9DisNBggANU6B1UrifGvVU/ChatGPT_Image_6_Φεβ_2026,_06_15_58_μ.μ..png" alt="Man looking at himself in mirror, noticing positive transformation" className="w-full h-auto rounded-lg" data-id="element-264" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-265">
                But the biggest change? The mental obsession was gone.
              </p>

              <p className="mb-6" data-id="element-266">
                I wasn't spending all day thinking about whether I'd drink that
                night. I wasn't making rules or bargaining with myself. I wasn't
                white-knuckling my way through each evening.
              </p>

              <p className="mb-8" data-id="element-267">I was just... living. Present. In control.</p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-268">
                By week two, my son was asking me to play catch again.
              </p>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-269">
                This Isn't Just My Story. Thousands of Men Are Experiencing the
                Same Transformation.
              </h2>

              <TestimonialBox testimonials={testimonials} data-id="element-270" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-271">
                Here's What Makes This Different From Everything Else You've
                Tried
              </h2>

              <p className="mb-6" data-id="element-272">
                The patch is called Glisera, and it's specifically designed for
                high-functioning adults whose drinking is driven by chronic
                stress and nervous system dysregulation.
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-273">
                It's not a medication. It's not addictive. And it doesn't
                require you to admit you're an "alcoholic" or attend meetings or
                tell anyone what you're doing.
              </p>

              <p className="mb-8" data-id="element-274">
                It's discreet, private, and science-backed support for your
                overstimulated nervous system.
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-275">
                Here's what's actually in it:
              </p>

              <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-276">
                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-277">
                  Kudzu Extract
                </h3>
                <p className="mb-4" data-id="element-278">
                  Used in traditional medicine for over 1,000 years to reduce
                  alcohol cravings. Clinical studies show it helps regulate
                  dopamine response and reduces the compulsion to drink. It
                  doesn't make you sick if you do drink—it simply makes you want
                  it less.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-279">
                  High-Dose B-Vitamins (B1, B6, B12) + Magnesium
                </h3>
                <p className="mb-4" data-id="element-280">
                  Alcohol rapidly depletes these essential nutrients. Without
                  them, your nervous system can't produce calming
                  neurotransmitters like GABA or regulate stress hormones like
                  cortisol. The patch replenishes these nutrients continuously,
                  giving your brain what it needs to feel calm naturally.
                </p>

                <h3 className="text-lg font-bold text-gray-900 mb-3 font-sans" data-id="element-281">
                  Adaptogenic Herb Blend (Ashwagandha, Rhodiola, Holy Basil)
                </h3>
                <p data-id="element-282">
                  These herbs have been clinically shown to lower cortisol
                  levels, restore healthy stress response, and activate your
                  parasympathetic nervous system (the "brake pedal"). They help
                  your body shift out of fight-or-flight mode and into
                  rest-and-digest mode—without alcohol.
                </p>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mt-8 mb-4 font-sans" data-id="element-283">
                The Transdermal Advantage
              </h3>

              <p className="mb-6" data-id="element-284">
                Here's why the patch works when pills and supplements don't:
              </p>

              <p className="mb-6 font-bold text-gray-900" data-id="element-285">
                Alcohol damages your gut lining. That means even if you're
                taking supplements by mouth, your body can't absorb them
                properly.
              </p>

              <p className="mb-6" data-id="element-286">
                But transdermal delivery (through the skin) bypasses your
                digestive system entirely. The ingredients are absorbed directly
                into your bloodstream and delivered continuously for 24 hours.
              </p>

              <p className="mb-8" data-id="element-287">
                No spikes. No crashes. Just steady, reliable support.
              </p>

              <p className="mb-8" data-id="element-288">
                It works while you work. While you sleep. While you're living
                your life.
              </p>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 my-8" data-id="element-289">
                <p className="text-blue-900 font-bold text-lg" data-id="element-290">
                  Over 89% of users report significantly reduced cravings within
                  the first 7 days.
                </p>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 font-sans" data-id="element-291">
                "But I've Tried Everything... How Is This Different?"
              </h2>

              <p className="mb-6" data-id="element-292">
                I know what you're thinking. I thought the same thing.
              </p>

              <p className="mb-6 italic text-gray-700" data-id="element-293">
                "I've tried supplements before. They didn't work."
                <br data-id="element-294" />
                "I've tried willpower. I kept drinking."
                <br data-id="element-295" />
                "I've tried apps and books and programs. Nothing stuck."
              </p>

              <p className="mb-6 font-bold text-gray-900 text-lg" data-id="element-296">
                Here's why this is different:
              </p>

              <p className="mb-8 font-bold text-gray-900" data-id="element-297">
                Everything else you tried was treating the symptoms.
              </p>

              <ul className="space-y-3 mb-8 list-none pl-0" data-id="element-298">
                <li className="flex items-start" data-id="element-299">
                  <span className="text-red-500 mr-2" data-id="element-300">✗</span>
                  <span data-id="element-301">
                    Apps track your drinking but don't calm your nervous system.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-302">
                  <span className="text-red-500 mr-2" data-id="element-303">✗</span>
                  <span data-id="element-304">
                    Therapy explores your past but doesn't replenish depleted
                    GABA.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-305">
                  <span className="text-red-500 mr-2" data-id="element-306">✗</span>
                  <span data-id="element-307">
                    AA focuses on abstinence but doesn't address cortisol
                    overload.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-308">
                  <span className="text-red-500 mr-2" data-id="element-309">✗</span>
                  <span data-id="element-310">
                    Pills and supplements get destroyed in your damaged gut
                    before they can help.
                  </span>
                </li>
              </ul>

              <p className="mb-8 font-bold text-gray-900 text-xl" data-id="element-311">
                Glisera targets the root cause: your overstimulated nervous
                system.
              </p>

              <p className="mb-8" data-id="element-312">
                When your body gets the support it's been desperately
                lacking—when cortisol regulates, when GABA replenishes, when
                your nervous system can finally shift gears naturally—the
                craving simply fades.
              </p>

              <p className="mb-12 font-bold text-gray-900" data-id="element-313">
                You're not fighting it. You're not white-knuckling it. You're
                not using willpower.
              </p>

              <p className="mb-12 text-xl font-bold text-gray-900" data-id="element-314">
                You just... don't want it anymore.
              </p>

              <div className="bg-gray-50 p-8 rounded-lg my-12" data-id="element-315">
                <h3 className="text-xl font-bold text-gray-900 mb-6 font-sans" data-id="element-316">
                  Common Questions
                </h3>

                <div className="space-y-6" data-id="element-317">
                  <div data-id="element-318">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-319">
                      "Will people know I'm wearing it?"
                    </h4>
                    <p className="text-gray-700" data-id="element-320">
                      No. The patch is small, thin, and flesh-toned. You wear it
                      on your upper arm or shoulder blade—completely hidden
                      under normal clothing. It stays on through showers,
                      workouts, and sleep.
                    </p>
                  </div>

                  <div data-id="element-321">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-322">
                      "What if I'm not ready to quit completely?"
                    </h4>
                    <p className="text-gray-700" data-id="element-323">
                      You don't have to. This isn't an abstinence program. Many
                      people find they can moderate once their nervous system is
                      supported. Others discover they prefer life without
                      alcohol. Either way, you're in control—not the craving.
                    </p>
                  </div>

                  <div data-id="element-324">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-325">
                      "I'm scared to hope again..."
                    </h4>
                    <p className="text-gray-700" data-id="element-326">
                      I understand. After every failed attempt, hope feels
                      dangerous.
                    </p>
                    <p className="text-gray-700 mt-2 font-bold" data-id="element-327">
                      But here's the truth: you didn't fail because you're weak.
                      You failed because you were trying to solve a biological
                      problem with behavioral solutions.
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-328">
                      This is different. And it comes with a 60-day money-back
                      guarantee. If it doesn't work, you get every penny back.
                      No questions asked.
                    </p>
                    <p className="text-gray-700 mt-2 italic" data-id="element-329">
                      You have nothing to lose except the next 3 AM panic
                      attack.
                    </p>
                  </div>
                </div>
              </div>

              <CTASection variant="primary" data-id="element-330" />

              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-16 mb-6 font-sans" data-id="element-331">
                One Last Thing
              </h2>

              <p className="mb-6" data-id="element-332">
                That Saturday afternoon when Jake asked me to play catch and I
                said "maybe later"—that was four months ago.
              </p>

              <p className="mb-6" data-id="element-333">
                This morning, he came into the kitchen and asked if I wanted to
                shoot hoops before school.
              </p>

              <p className="mb-6" data-id="element-334">
                We played for 30 minutes. I was fully there. Fully present.
              </p>

              {/* IMAGE 8: Father and son playing basketball - happy ending */}
              <div className="my-8 rounded-lg overflow-hidden shadow-sm" data-id="element-335">
                <img src="https://cdn.magicpatterns.com/uploads/9ZReZAHL4EuKtWaJwcVwVX/ChatGPT_Image_6_Φεβ_2026,_06_15_56_μ.μ..png" alt="Father and son playing basketball in driveway, morning, both smiling" className="w-full h-auto rounded-lg" data-id="element-336" />
              </div>

              <p className="mb-6 font-bold text-gray-900" data-id="element-337">
                He told me, "You're way better at basketball now, Dad."
              </p>

              <p className="mb-6" data-id="element-338">
                I laughed. "I'm the same as I've always been, bud."
              </p>

              <p className="mb-6" data-id="element-339">"No," he said. "You're different. Better."</p>

              <p className="mb-8" data-id="element-340">
                I can't describe what that felt like. To have my son back. To
                have myself back.
              </p>

              <p className="mb-8 text-xl font-bold text-gray-900" data-id="element-341">
                The shame dies when you take action.
              </p>

              <p className="mb-6" data-id="element-342">
                Your nervous system has been flooded with stress hormones for
                years. It's not your fault you've been using alcohol to cope.
                But now you know there's another way.
              </p>

              <p className="mb-12" data-id="element-343">
                You deserve to feel calm. You deserve to sleep through the
                night. You deserve to be present. You deserve your life back.
              </p>

              <p className="mb-12 font-bold text-gray-900 text-xl" data-id="element-344">
                And it starts with one simple decision.
              </p>

              <CTASection variant="final" data-id="element-345" />
            </div>
          </article>

          {/* Sidebar Column */}
          <aside className="hidden lg:block w-[35%]" data-id="element-346">
            <ProductSidebar data-id="element-347" />
          </aside>
        </div>
      </main>

      <StickyBottomBar data-id="element-348" />
    </div>;
}